export default [
  {
    path: 'recomment',
    name: '亿车介绍',
    meta:{
     title:'亿车介绍'
    },
    component: () =>
      import(/* webpackChunkName: "aboutRecomment" */ '@/views/about/recomment'),
  },
  // {
  //   path: 'news',
  //   name: '新闻中心',
  //   component: () =>
  //     import(/* webpackChunkName: "aboutNews" */ '@/views/about/news'),
  // },
  {
    path: 'cultrue',
    name: '企业文化',
    meta:{title:'企业文化'},
    component: () =>
      import(/* webpackChunkName: "aboutCultrue" */ '@/views/about/cultrue'),
  },
  {
    path: 'video',
    name: '亿车视频',
    meta:{title:'亿车视频'},
    component: () =>
      import(/* webpackChunkName: "aboutVideo" */ '@/views/about/video'),
  },
  {
    path: 'joinus',
    name: '社会招聘',
    meta:{title:'社会招聘'},
    component: () =>
      import(/* webpackChunkName: "aboutJoinus" */ '@/views/about/joinus'),
  },
  // {
  //   path: 'campusemploy',
  //   name: '校园招聘',
  //   meta:{title:'校园招聘'},
  //   component: () =>
  //     import(/* webpackChunkName: "aboutJoinus" */ '@/views/about/campusemploy'),
  // },
];
